/** @format */

import React from 'react';
import { Card, Button } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Customer } from '../types/customer';

dayjs.extend(utc);

interface PersonalInfoCardProps {
  customer: Customer;
  isEditing: boolean;
  onToggleEdit: () => void;
  onCancelEdit: () => void;
  onInputChange: (field: string, value: any) => void;
}

const PersonalInfoCard: React.FC<PersonalInfoCardProps> = ({
  customer,
  isEditing,
  onToggleEdit,
  onCancelEdit,
  onInputChange,
}) => {
  const formatDateOfBirth = (person: any): string => {
    if (!person) return 'N/A';
    const dateOfBirth = person.dateOfBirth || person.dob;
    if (!dateOfBirth) return 'N/A';
    const date = dayjs.utc(dateOfBirth);
    if (!date.isValid()) return 'N/A';
    return date.format('MM/DD/YYYY');
  };

  return (
    <Card
      title="Personal Information"
      extra={
        isEditing ? (
          <>
            <Button onClick={onToggleEdit} style={{ marginRight: '8px' }}>
              Save
            </Button>
            <Button onClick={onCancelEdit}>
              Cancel
            </Button>
          </>
        ) : (
          <Button onClick={onToggleEdit}>
            Edit
          </Button>
        )
      }
    >
      <div style={{ padding: '10px' }}>
        <p><strong>Lead ID:</strong> {customer.leadId}</p>
        <p>
          <strong>First Name:</strong> {customer.firstName}
        </p>
        <p>
          <strong>Last Name:</strong> {customer.lastName}
        </p>
        <p>
          <strong>Phone:</strong> {customer.phoneNumber}
        </p>
        <p>
          <strong>Email:</strong> {customer.email || 'N/A'}
        </p>
        <p>
          <strong>Date of Birth:</strong> {formatDateOfBirth(customer)}
        </p>
        <p>
          <strong>Household Income:</strong> {customer.householdIncome || 'N/A'}
        </p>
        <p>
          <strong>Occupation:</strong> {customer.typeOfWork || customer.occupation || 'N/A'}
        </p>
        <p>
          <strong>SSN:</strong> {customer.SSN || customer.ssn}
        </p>
        <p>
          <strong>FFM ID:</strong>
          {isEditing ? (
            <input
              type="text"
              value={customer.FFMId || ''}
              onChange={(e) => onInputChange('FFMId', e.target.value)}
            />
          ) : (
            customer.FFMID || customer.FFMId || 'N/A'
          )}
        </p>
        <p>
          <strong>Member ID:</strong>
          {isEditing ? (
            <input
              type="text"
              value={customer.memberId || ''}
              onChange={(e) => onInputChange('memberId', e.target.value)}
            />
          ) : (
            customer.memberId || 'N/A'
          )}
        </p>
      </div>
    </Card>
  );
};

export default PersonalInfoCard;
